import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import classNames from 'classnames';

import { useResponsiveBreakpoints } from '../../../hooks/useResponsiveBreakpoints';

import StageProgress from '../CraftCycleDetailPage/StageProgress/StageProgress';
import TimestampDisplay from '../../../design-system/TimestampDisplay/TimestampDisplay';
import { Badge, Button } from '../../../design-system';
import { LoopRightFillIcon } from '../../../design-system/Icons';

const CycleCard = ({ cycle }) => {
    const { id, name, current_stage, updated_at } = cycle;
    const { progress, stage_status } = current_stage || {};
    const { status_label, status_color } = stage_status || {};

    const navigate = useNavigate();
    const location = useLocation();

    const cardContainerClassName = classNames(
        'px-4 py-3 rounded bg-white',
        'grid grid-rows-[auto_auto_auto] min-[940px]:grid-rows-[auto_auto] xl:grid-rows-1 grid-cols-[32px_minmax(100px,_1fr)_100px] min-[335px]:grid-cols-[32px_minmax(100px,_1fr)_120px] xs:grid-cols-[32px_minmax(100px,_1fr)_160px] min-[940px]:grid-cols-[32px_minmax(100px,_1fr)_210px_130px] lg:grid-cols-[32px_minmax(100px,_1fr)_240px_150px] xl:grid-cols-[40px_minmax(100px,_1fr)_200px_220px_140px_85px] 3xl:xl:grid-cols-[40px_minmax(100px,_1fr)_228px_250px_160px_105px] gap-x-3 lg:gap-x-4 3xl:gap-x-5 gap-y-1.5 min-[720px]:gap-y-2 items-center'
    );

    const renderViewButton = () => (
        <Button
            type="link"
            size="xs"
            text={isSmallMobile ? 'View' : 'View Cycle'}
            onClick={() => navigate(`/cycle/${id}`, { state: { from: location } })}
        />
    );

    const { isMobile: isSmallMobile, isDesktop: isLargeDesktop } = useResponsiveBreakpoints({
        minDesktopWidth: 1280,
        maxMobileWidth: 400,
    });
    const iconSize = isLargeDesktop ? 32 : 24;

    return (
        <div className={cardContainerClassName}>
            <div className="w-[32px] h-[32px] min-w-[32px] xl:w-10 xl:h-10 xl:min-w-[40px] flex items-center justify-center">
                <LoopRightFillIcon width={iconSize} height={iconSize} color="#000000" />
            </div>

            <p className="font-body-bold text-body-bold-s xl:text-body-bold-m text-meutral-500 truncate col-span-2 min-[940px]:col-span-1">
                {name}
            </p>

            <div className="-mb-1 -mt-1 xl:mb-0 xl:mt-0 border-t-1 border-neutral-200 xl:border-none flex justify-between xl:justify-start row-start-3 row-end-3 col-span-full min-[940px]:row-start-2 min-[940px]:row-end-2 xl:row-start-auto xl:row-end-auto xl:col-span-1">
                <TimestampDisplay
                    label="Last Updated At"
                    timestamp={updated_at}
                    dateTimeFormat="MM/dd/yyyy"
                    variant="primary"
                />

                <div className="block xl:hidden">{renderViewButton()}</div>
            </div>

            <StageProgress
                name={current_stage?.name}
                progress={progress}
                containerClassName="col-span-2 min-[940px]:col-span-1"
                progressBarClassName="w-[106px] min-w-[106px] min-[356px]:w-[120px] min-[356px]:min-w-[120px] min-[400px]:w-[160px] min-[400px]:min-w-[160px]"
                truncate
            />

            <div>
                <div className="xl:w-[120px] 3xl:w-[130px] mr-auto text-right">
                    <Badge text={status_label} color={status_color} />
                </div>
            </div>

            <div className="hidden xl:flex justify-center">{renderViewButton()}</div>
        </div>
    );
};

export default CycleCard;
